'use client';
import { jsx } from 'react/jsx-runtime';
import t from 'prop-types';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const bannerImagePropTypes = {
    imageFocalPoint: t.oneOf([
        'left top',
        'left center',
        'left bottom',
        'center top',
        'center center',
        'center bottom',
        'right top',
        'right center',
        'right bottom'
    ])
};
let n = Object.keys(bannerImagePropTypes);
const BannerImage = renderWithRef('BannerImage', bannerImagePropTypes, (t, r)=>{
    let a = new Set([
        'swan-banner-image'
    ]);
    t.imageFocalPoint && a.add(`swan-banner-image-focal-point-${t.imageFocalPoint.replace(/ +/g, '-')}`);
    let { children: p } = t;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: r,
        propKeysToRemove: n,
        classNames: a,
        props: t,
        children: p
    });
});

export { BannerImage, bannerImagePropTypes };
